import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-header-publicSentiment",
  "use": "icon-header-publicSentiment-usage",
  "viewBox": "0 0 2048 2048",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 2048 2048\" id=\"icon-header-publicSentiment\"><path d=\"M1408 512h512v512h-128V731l-576 575l-256-256l-704 705v37h1664v128H128V128h128v1445l704-703l256 256l485-486h-293z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol